package com.anjuros.website.templates.template8.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosBackgroundImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template8.modules.Template8Section
import com.anjuros.website.templates.template8.styles.Template8NavigationItemStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.anjuros.website.templates.template8.util.Template8CompanyDetails
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8Header(onMenuCLicked: () -> Unit,
                    clickable:Boolean = true) {

    Box(modifier = Modifier.fillMaxSize()
        .height(70.px),
    ) {
        AnjurosBackgroundImage(
            modifier = Modifier.fillMaxWidth()
                .height(70.px)
                .align(Alignment.Center)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_header_background,
            alt = "Pub menu"
        )
        Template8LeftSide(
            modifier = Modifier.align(Alignment.CenterStart)
        ) { onMenuCLicked() }
        Template8Menu(modifier = Modifier.align(Alignment.CenterStart),
            clickable = clickable)
        Template8HeaderCall(modifier = Modifier.align(Alignment.CenterEnd)
            .displayIfAtLeast(Breakpoint.LG)
        )
    }
}


@Composable
fun Template8LeftSide(
    modifier: Modifier,
    onMenuCLicked: () -> Unit
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center) {

        Box(
            modifier = Modifier
                .size(
                40.px
            ).onClick { onMenuCLicked() }
                .zIndex(1f)
        ) {


            MenuIcon(
                modifier = Modifier
                    .align(Alignment.Center)
                    .displayUntil(Breakpoint.LG)
                    .margin(left = 15.px)
                    .color(Template8Theme.Primary.rgb)
            )
        }
    }
}

@Composable
fun Template8HeaderCall(modifier: Modifier){

    Link(path = "tel:${Template8Constants.CLIENTS_PHONE}",
        modifier=modifier.textDecorationLine(TextDecorationLine.None)
            .margin(right = 20.px)) {

        P(
            attrs = Template8NavigationItemStyle.toModifier()
                .fillMaxWidth()

                .textAlign(TextAlign.Center)

                .margin(topBottom = 0.px)
                .fontFamily(Template8Constants.FONT_FAMILY)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text("Call us: ")
            AnjurosText(Template8CompanyDetails.CLIENTS_PHONE_INFO)

        }
    }
}

@Composable
fun Template8Menu(
    modifier: Modifier,
    clickable:Boolean = true
) {

    Row(
        modifier = modifier
            .displayIfAtLeast(Breakpoint.LG)
            .padding(10.px),
        horizontalArrangement = Arrangement.End
    ) {

        Template8Section.entries.toTypedArray().forEach { section ->


            Column(modifier = Modifier
                .padding(leftRight = 15.px),
                horizontalAlignment = Alignment.CenterHorizontally) {
                Link(
                    modifier = Modifier
                        .align(Alignment.CenterHorizontally)
                        .textDecorationLine(TextDecorationLine.None),

                    path = if(clickable){section.path
                    } else "")
                {
                    P(
                        attrs = Template8NavigationItemStyle.toModifier()
                            .fillMaxWidth()
                            .align(Alignment.CenterHorizontally)
                            .textAlign(TextAlign.Center)

                            .margin(topBottom = 0.px)
                            .fontFamily(Template8Constants.FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Normal)
                            .toAttrs()
                    ) {
                        Text(LocalText(section.title))

                    }
                }

                if(window.location.pathname.equals(section.path)){
                    Box(modifier = Modifier
                        .align(Alignment.CenterHorizontally)
                        .width(50.px).height(2.px).backgroundColor(
                            Template8Theme.Primary.getColor()))
                }
            }

        }

    }
}